import EnterpriseLogo from './plan-icons/plan-icon-enterprise.svg';
import MaxLogo from './plan-icons/plan-icon-max.svg';
import ScaleLogo from './plan-icons/plan-icon-scale.svg';

/** Accepts a bare plan name as well as a `PLAN` member, which is how most callers pass it. */
export type PlanLogoName = 'scale' | 'lite' | 'max' | 'pro' | 'enterprise' | 'custom';

// Lite and Pro have no artwork of their own yet, so they borrow the plan each replaces.
export const PLAN_LOGOS: Record<PlanLogoName, string> = {
  scale: ScaleLogo,
  lite: ScaleLogo,
  max: MaxLogo,
  pro: MaxLogo,
  enterprise: EnterpriseLogo,
  custom: EnterpriseLogo,
};
